export default __webpack_public_path__ + "static/media/Amanda.ce816b8f.jpg";